import _ from 'lodash';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  APPLICATION_ID,
  authFeatureConstants,
  PROFILE_CONSTANTS,
} from '../../../shared/constants/commonConstants';
import {
  DASHBOARD_POWER_BI,
  FETCH_DASHBOARD,
} from '../../../shared/constants/urlEndPoints';
import { PBIRequest, PBIResponse } from '../../../shared/models/account.model';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import SendRequest from '../../../shared/services/sendRequest.service';
import { dashBoardRequest } from '../../../store/actions/leftSideBarAction';
import NoDataFound from '../../inventry/shared/NoDataFound';
import { Skeleton } from 'antd';
import { powerBiConstants } from '../../../shared/constants/powerBI';
import { canActivate } from '../../../utils/utility';

const ReconciliationDashboard = ({ dashboardType }: any): ReactElement => {
  const [pbiData, setPBIData] = useState({} as PBIResponse);
  const [filterValue, setFilterValue] = useState<any>([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const dispatch = useDispatch();
  const hospitalProfileData = useSelector(
    ({ hospital: { hospitalProfile } }: any): any => hospitalProfile,
  );

  useEffect((): void => {
    dispatch(
      dashBoardRequest({
        title: PROFILE_CONSTANTS.profile,
        url: `${process.env.REACT_APP_BASE_URL}${FETCH_DASHBOARD}`,
        type: PROFILE_CONSTANTS.profile,
      }),
    );
    getPBIData(); // removing supreme id depenedency as profile id is fetched from Login and Hospotal Detals API
  }, [hospitalProfileData]);

  const getPBIData = async (): Promise<void> => {
    const url = process.env.REACT_APP_BASE_URL + DASHBOARD_POWER_BI;
    const payload: PBIRequest = {
      applicationId: APPLICATION_ID,
      dashboardType,
      profileId: ApplicationDetail.instance.getProfileId(),
    };
    const response: any = await SendRequest.instance.post<
      PBIRequest,
      PBIResponse
    >(url, payload);
    setIsDataLoaded(true);
    if (response && response.isSuccess) {
      setPBIData(response);
      powerBiConstants.ihxFinanceProvider.filter.values = [];

      const groupProviders = ApplicationDetail.instance.getGroupProviders();
      const filters: any = [];
      if (groupProviders?.length) {
          powerBiConstants.ihxFinanceProvider.filter.values = groupProviders?.map(({ providerId }: any): any => providerId);
          filters.push(powerBiConstants.ihxFinanceProvider.filter);

          if (canActivate(authFeatureConstants.RECONCILIATION_VENDOR_FILTER)) {
            filters.push({
              $schema: 'http://powerbi.com/product/schema#advanced',
              target: {
                table: 'Hospital Claim Data',
                column: 'ClusterVenderIdSupremeId',
              },
              operator: 'In',
              values: [ApplicationDetail.instance.getProviderId()] as any,
            });
          }
      } else {
        powerBiConstants.ihxFinanceProvider.filter.values = [ApplicationDetail.instance.getProviderId()];
        filters.push(powerBiConstants.ihxFinanceProvider.filter);
      }
      setFilterValue(filters);
    }
  };
  return (
    <div style={{ height: 'calc(130vh)', display: 'flex', alignItems: 'top' }}>
      {pbiData && !_.isEmpty(pbiData) && isDataLoaded && filterValue?.length > 0 && (
        <PowerBIEmbed
          embedConfig={{
            type: 'report',
            id: pbiData.id,
            embedUrl: pbiData.embedUrl,
            accessToken: pbiData.embedToken?.token,
            tokenType: models.TokenType.Embed,
            permissions: models.Permissions.All,
            settings: {
              hideErrors: false,
              filterPaneEnabled: false,
              navContentPaneEnabled: false,
              bookmarksPaneEnabled: false,
              localeSettings: {
                formatLocale: '',
                language: '',
              },
            },
            filters: filterValue,
          }}
          cssClassName={'core-pbi-dashboard1'}
        />
      )}
      {isDataLoaded && _.isEmpty(pbiData) && <NoDataFound />}
      {!isDataLoaded && _.isEmpty(pbiData) && (
        <div style={{ width: '100%', height: '100%', padding: '24px' }}>
          <Skeleton active={true} paragraph={{ rows: 5 }} />
        </div>
      )}
    </div>
  );
};

export default ReconciliationDashboard;
